/**
 * App info — the "How to use" guide + "News from the creator".
 * Reads for everyone; writes are super-admin-only (server-enforced).
 */
import apiClient from '../api/client';

const appInfoService = {
    // News
    async listNews() { return apiClient.get('/app-info/news'); },
    async createNews(post) { return apiClient.post('/app-info/news', post); },
    async updateNews(id, patch) { return apiClient.put(`/app-info/news/${id}`, patch); },
    async deleteNews(id) { return apiClient.delete(`/app-info/news/${id}`); },

    // Guides
    async listGuides(department) {
        const q = department ? `?department=${encodeURIComponent(department)}` : '';
        return apiClient.get(`/app-info/guides${q}`);
    },
    async createGuide(section) { return apiClient.post('/app-info/guides', section); },
    async updateGuide(id, patch) { return apiClient.put(`/app-info/guides/${id}`, patch); },
    async deleteGuide(id) { return apiClient.delete(`/app-info/guides/${id}`); },
};

export default appInfoService;
